import React from "react";
import "../../index.scss";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "../../index.scss";
import "./Responsive.scss";

const SavaSumanovicText = () => {
  return (
    <Container
      sm={{ span: 12 }}
      md={{ span: 12 }}
      lg={{ span: 12 }}
      xl={{ span: 12 }}
      className="container-artist-data"
    >
      <Row>
        <Col
          sm={{ span: 12 }}
          md={{ span: 11, offset: 1 }}
          lg={{ span: 11, offset: 0 }}
          xl={{ span: 11, offset: 0 }}
        >
          <div className="artist-info-text" style={{ width: "100%" }}>
            <p style={{ color: "dimgray" }}>
              <font color="black">
                <b>Sava Šumanović </b>
              </font>
              je rođen 22. januara 1896. u Vinkovcima u imućnoj građanskoj
              porodici, Perside i Milutina Šumanovića. Posle ranog očevog
              penzionisanja 1900. porodica se vraća u Šid, gde Sava pohađa
              osnovnu školu. <br />
              <br />
              <font color="#414141">
                <b>1906–1914</b>
              </font>
              <br />
              Upisuje Realnu gimnaziju u Zemunu. Crtanje mu predaje profesor
              Isidor Jung. Kod istog profesora pohađa i privatne časove na
              kojima se upoznaje sa impresionističkim načinom slikanja,
              umetnošću Sezana i Van Goga. Druguje sa Slavkom Vorkapićem. Leta
              provodi u Šidu i Gracu. Gimnaziju završava 1914.
              <br />
              <br />
              <font color="#414141">
                <b>1914–1918</b>
              </font>
              <br />
              Polaže prijemni ispit i upisuje Višu školu za umjetnost i obrt u
              Zagrebu. U klasi je profesora Otona Ivekovića i Menci Klement
              Crnčića. Druži se i prijatelj je sa Marijanom Trepšeom, Đurom
              Tiljkom, Milanom Štajnerom, Hinkom Junom, Srećkom Sabljakom. Prvi
              put grupno izlaže na Školskoj izložbi 1916. Samostalno (sa B.
              Carom) u Ulrihovom salonu 1918. Iste godine završava školu i
              iznajmljuje atelje u Šubićevoj 8a.
              <br />
              <br />
              <font color="#414141">
                <b>1919–1920</b>
              </font>
              <br />
              Slika sa Milanom Štajnerom. Druži se i sarađuje sa Antnom Brankom
              Šimićem. Priprema skice i velika platna za Narodno kazalište.
              Izveo scenografiju za Don Žuana V. A. Mocarta (premijera 1. juna
              1920). Radi ilustracije, opremu knjiga, nekoliko grafika.
              Intenzivno slika. Priređuje drugu samostalnu izložbu u Zagrebu.
              Doživljava uspeh kod kritike i otkup. Stimulisan uspehom i očevom
              podrškom, septembra 1920. odlazi u Pariz. Stanuje u Rue Bréa 15.
              Prvih meseci intenzivno crta i slika, obilazi muzeje i galerije,
              upoznaje umetnički Pariz.
              <br />
              <br />
              <font color="#414141">
                <b>1921–1925</b>
              </font>
              <br />
              Pohađa atelje Andre Lota. Jedan je od najboljih đaka. Intenzivno
              radi. Sa velikim oduševljenjem i brojnim slikama vraća se u
              Zagreb, gde priređuje samostalnu izložbu za koju je napisao
              predgovor. Doživljava neuspeh kod publike i nerazumevanje jednog
              dela stručnjaka kojima je kubizam i postkubizam nepoznat i stran.
              Satisfakciju dobija od eminentnih kritičara Antuna Branka Šimića,
              Rastka Petrovića, Ljubomira Micića, Pjera Križanića. Zakupljuje
              prostorije u Prilazu 49, mađutim malo slika. Izlaže na{" "}
              <em>Proljetnim salonima i V jugoslovenskoj umetničkoj izložbi</em>
              . Kraće vreme (1922) je u državnoj službi u zvanju bibliotekara
              Muzeja za umjetnost i obrt. Objavljuje u <em>Književniku</em>{" "}
              1924. tekstove <em>Slikar o slikarstvu</em> i{" "}
              <em>Zašto volim Pusenovo slikarstvo</em> u kojima objašnjava svoj
              slikarski stav.
              <br />
              <br />
              <font color="#414141">
                <b>1925–1928</b>
              </font>
              <br />
              Krajem maja odlazi drugi put u Pariz. Zakupljuje atelje u Rue
              Danwil 5. Crta po Lotovim sugestijama ali retko odlazi u njegov
              atelje. Izlaže na{" "}
              <em>Salon des Independants i Salon d` Automne</em>. Sa{" "}
              <em>Jesenjeg salona</em> 1926. francuska vlada otkupljuje sliku{" "}
              <em>Akt</em>. U kritikama ga zapažaju Florent Fels, Jacques
              Guenne, Georges Turpin. Prilikom preuređenja kafane{" "}
              <em>La Coupole</em> pozvan je da naslika dve kompozicije na
              stubovima koje su sačuvane. Za <em>Salon des Independant</em>{" "}
              1927. intenzivno slika kompoziciju <em>Pijani brod</em>. Kritika
              pozitivno ocenjuje delo, ali su usmeni komentari oprečni.
              Negativne primedbe utiču na već oslabljenu psihičku stabilnost
              umetnika, tako da februara 1928. doživljava nervni slom. Posle
              kraćeg lečenja napušta Pariz. Brzo se oporavlja u Šidu i slika.
              Nastaju brojni pejzaži koje sa delima nastalim u Parizu 1927. i
              1928. izlaže na Novom univerzitetu u Beogradu. Izložba je odlično
              prihvaćena. Zdravstveno stanje se poboljšava, tako da se oktobra
              vraća u Pariz.
              <br />
              <br />
              <font color="#414141">
                <b>1929–1930</b>
              </font>
              <br />
              Adaptira atelje u Rue Denfert – Rochereau. Slika cikluse aktova i
              pejzaža Pariza, Orsay-a, Aarcenilles-a. Posle uspeha 1927. cenjen
              je i pozivan. Upoznaje mnoge umetnike Pariza, prijateljuje sa
              Pascinom. Međutim, nervna napetost traje i dalje. Nakon
              nesporazuma sa žirijem i neizlaganja na
              <em>Jesenjem salonu</em>, zdravlje mu se naglo pogoršava. Marta
              1930. zauvek napušta Francusku.
              <br />
              <br />
              <font color="#414141">
                <b>1930–1932</b>
              </font>
              <br />
              Vraća se u Šid. Teško oboleo leči se tri meseca, zatim dve godine
              na klinikama u Beogradu.
              <br />
              <br />
              <font color="#414141">
                <b>1932–1939</b>
              </font>
              <br />
              Ponovo je u Šidu koji gotovo ne napušta do smrti. Izolovan od
              spoljnjeg sveta mirno živi u rodnoj kući na selu i vraća se
              slikarstvu. Intenzivno radi. Slika motive iz Šida. Nastaju ciklusi{" "}
              <em>Šidske ulice</em>, <em>Proleće u dolini Sv. Petke</em>,{" "}
              <em>Proleće u šidskim baštama</em>,<em>Kupačice</em>,{" "}
              <em>Aktovi</em>.<br />
              <br />
              <font color="#414141">
                <b>1939</b>
              </font>
              <br />
              Posećuje izložbu Savremenog francuskog slikarstva u Beogradu i
              odlučuje se na šestu samostalnu izložbu koju otvara septembra na
              Novom univerzitetu. Izložba sa neuobičajeno velikim brojem od 410
              slika bila je izuzetan likovni događaj. Priznanje kritike, velika
              poseta, prodaja iznad očekivanja su krunisale povratak izolovanog
              slikara i potvrdile ga kao jednog od najvećih jugoslovenskih
              umetnika.
              <br />
              <br />
              <font color="#414141">
                <b>1940–1942</b>
              </font>
              <br />
              Pozvan je na vojnu vežbu krajem januara 1941. u Osijek. Dodeljen
              je radničkom bataljonu u svojstvu crtača. Po izbijanju rata i
              kapitulaciji Jugoslavije, bataljon se u Tuzli predaje Nemcima.
              Kraće vreme je u vojnom logoru. Otpušten kući 19. aprila.
              Usporenim tempom i dalje slika ustaljene motive – šidske pejzaže,
              kompozicije sa aktovima, beračice, portrete. Uhapšen 28. avgusta
              1942. i kao taoc streljan u noći između 29. i 30. avgusta od
              ustaša u Sremskoj Mitrovici.
              <br />
              <br />
              <font color="#414141">
                <b>1952</b>
              </font>
              <br />
              Majka poklanja dela Save Šumanovića i dve reprezentativne zgrade
              za memorijalni muzej. Galerija Save Šumanovića je otvorena u Šidu
              21. septembra. Poseduje fond od 417 dela, 356 uljanih slika i 61
              delo na papiru – crteža, akvarela i pastela.
              <br />
              <br />
              <font color="#414141">
                <b>1958</b>
              </font>
              <br />
              Avala film iz Beograda snima dokumentarni film o Savi Šumanoviću –{" "}
              <em>Putevi</em> u režiji i po scenariju Aleksandra Petrovića i
              umetničkog snimatelja Nikole Majdaka.
              <br />
              <br />
              <font color="#414141">
                <b>1960</b>
              </font>
              <br />
              Publikovana monografija Save Šumanovića koju je napisao Dimitrije
              Bašićević u izdanju Društva historičara umjetnosti, Zagreb.
              <br />
              <br />
              <font color="#414141">
                <b>1962</b>
              </font>
              <br />
              Osnovan <em>Memorijal Save Šumanovića</em> u Šidu. Priređena
              komemorativna izložba povodom dvadesetogodišnjice smrti u
              Kulturnom centru u Beogradu. Izbor radova (66) i predgovor
              kataloga Momčilo Stevanović.
              <br />
              <br />
              <br />
              Biografija preuzeta iz: Radmila Matić, Biografija, u:{" "}
              <em>Sava Šumanović 1896–1942. retrospektivna izložba</em>, Muzej
              savremene umetnosti, Beograd, april–jun 1984. str.51–52
            </p>
          </div>
          <br />
        </Col>
      </Row>
    </Container>
  );
};

export default SavaSumanovicText;
